import { render, staticRenderFns } from "./InfluencerMonthlyCosts.vue?vue&type=template&id=038f6715"
import script from "./InfluencerMonthlyCosts.vue?vue&type=script&lang=js"
export * from "./InfluencerMonthlyCosts.vue?vue&type=script&lang=js"
import style0 from "./InfluencerMonthlyCosts.vue?vue&type=style&index=0&id=038f6715&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports